import React, { useState } from 'react';
import { BKJIcon } from '@bookjane2/bookjane-design-library';
import { Flex } from 'components/Flex';
import { shiftModalRoutingService } from 'modals/ShiftModal/ShiftModal.ui.context';
import { IRecurrenceListProps } from 'modals/ShiftModal/components/RecurrenceList/RecurrenceList.types';
import {
  RecurrenceListLabelWrapper,
  RecurrenceListLabel,
  RecurrenceListShift,
} from 'modals/ShiftModal/components/RecurrenceList/RecurrenceList.styled';
import { useTranslation } from 'hooks/useTranslation';

export const RecurrenceList: React.FC<IRecurrenceListProps> = ({ shifts }) => {
  const { t } = useTranslation();
  const [isOpen, setOpen] = useState<boolean>(true);

  const handleShiftClick = (shiftRelayId: string) => {
    shiftModalRoutingService.open({ shiftModalShiftId: shiftRelayId }, 'DetailView');
  };

  return (
    <Flex flexDirection="column" childMarginBottom="11px">
      <RecurrenceListLabelWrapper
        alignItems="center"
        childMarginRight="9.5px"
        onClick={() => setOpen(!isOpen)}
      >
        <RecurrenceListLabel>{t('schedule:SHIFTS_IN_RECURRENCE')}</RecurrenceListLabel>
        <BKJIcon iconName={isOpen ? 'ChevronUp' : 'ChevronDown'} />
      </RecurrenceListLabelWrapper>
      {isOpen && (
        <Flex flexDirection="column" childMarginBottom="11px">
          {shifts.map(({ id, relayId, orderSchedule }) => (
            <RecurrenceListShift onClick={() => handleShiftClick(relayId)} key={id}>
              {t('dashboard:SHIFT_NUMBER')}
              {orderSchedule.id}
            </RecurrenceListShift>
          ))}
        </Flex>
      )}
    </Flex>
  );
};
